import { COMPACT_SCREEN_MAX_WIDTH } from '@/constants/layout';
import { useMediaQuery } from 'react-responsive';

export const useCompactSidebar = () => useMediaQuery({ maxWidth: COMPACT_SCREEN_MAX_WIDTH });
